import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import { DropdownList } from 'react-widgets';
import { withTranslation } from 'react-i18next';
import ChildSelfAssessmentList from './ChildSelfAssessmentList';

class SelfAssessments extends Component {
	constructor(props) {
		super(props);
		this.handleChildSelect = this.handleChildSelect.bind(this);

		const { children } = this.props.parent;
		const firstChild = children && children[0];
		this.state = {
			selectedChildId: firstChild && firstChild.id
		};
	}

	handleChildSelect(value) {
		this.setState({ selectedChildId: value.id });
	}

	render() {
		const { parent, t } = this.props;
		const { selectedChildId } = this.state;

		let viewComponent = null;
		const childComponent = <div>
			{parent.children && parent.children.length > 0 && (parent.children.length > 1 ?
				<DropdownList style={{ marginBottom: '10px' }} data={parent.children} defaultValue={parent.children[0]} textField='fullName' valueField='id' onChange={this.handleChildSelect} /> :
				<h4 style={{ textAlign: 'center' }}>{parent.children[0].fullName}</h4>)}
		</div>;

		viewComponent = <div>{selectedChildId && <ChildSelfAssessmentList childId={selectedChildId} />}</div>;

		return <Panel>
			<Panel.Body>
				{childComponent}
				{viewComponent}
			</Panel.Body>
		</Panel>;
	}
}

export default withTranslation()(SelfAssessments);
